/**
 * Google API configuration and credential checks.
 * All Google integrations use this module.
 */

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

/**
 * @returns {boolean} True if a non-empty Maps API key is configured
 */
export function hasGoogleMapsKey() {
  return Boolean(GOOGLE_MAPS_API_KEY && String(GOOGLE_MAPS_API_KEY).trim());
}

/**
 * @returns {string} The Maps API key, or empty string if not configured
 */
export function getGoogleMapsApiKey() {
  return GOOGLE_MAPS_API_KEY;
}

/**
 * @returns {boolean} True if Google Places can be used (same key as Maps; both enabled in GCP)
 */
export function hasGooglePlacesKey() {
  return hasGoogleMapsKey();
}
